(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[767],{

/***/ "iygz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Reception", function() { return Reception; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Reception = function Reception(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    d: "M23.5925 14.54H21.2555L20.4899 11.45C20.2683 10.09 18.9789 9.07 17.4881 9.07H16.8938C17.881 8.5 18.5659 7.46 18.5659 6.25C18.5659 4.46 17.0952 3 15.2921 3C13.489 3 12.0183 4.46 12.0183 6.25C12.0183 7.46 12.6932 8.51 13.6905 9.07H13.1163C11.6154 9.07 10.3361 10.09 10.1044 11.45L9.33883 14.54H6.40751C5.07784 14.54 4 15.61 4 16.93V24.61C4 25.93 5.07784 27 6.40751 27H23.5925C24.9222 27 26 25.93 26 24.61V16.93C26 15.61 24.9222 14.54 23.5925 14.54ZM15.2921 4.99C15.9872 4.99 16.5513 5.55 16.5513 6.24C16.5513 6.93 15.9872 7.49 15.2921 7.49C14.5971 7.49 14.033 6.93 14.033 6.24C14.033 5.55 14.5971 4.99 15.2921 4.99ZM12.0687 11.88C12.0687 11.88 12.0788 11.81 12.0888 11.78C12.1493 11.38 12.5925 11.07 13.1163 11.07H13.902C14.456 11.06 14.9093 10.61 14.8993 10.05C14.8993 9.81 14.7985 9.6 14.6575 9.43C14.859 9.47 15.0705 9.49 15.2821 9.49C15.4936 9.49 15.6951 9.47 15.8965 9.43C15.7555 9.6 15.6648 9.81 15.6548 10.05C15.6548 10.6 16.098 11.05 16.652 11.06H17.4679C17.9817 11.06 18.435 11.38 18.4853 11.78C18.4853 11.81 18.4954 11.85 18.5055 11.88L19.1703 14.54H11.3938L12.0586 11.88H12.0687ZM23.9753 24.6C23.9753 24.81 23.804 24.99 23.5824 24.99H6.40751C6.19597 24.99 6.01465 24.82 6.01465 24.6V16.92C6.01465 16.71 6.1859 16.53 6.40751 16.53H23.5925C23.804 16.53 23.9853 16.7 23.9853 16.92V24.6H23.9753Z"
  }));
};

/***/ })

}]);